import { Skeleton, Text } from '@mntn/ui-components'
import { format } from 'date-fns'
import { DATE_FORMATS } from '@/components/shared/consts'
import { CountdownToStart } from '@/components/shared/countdown-to-start'
import type { LayoutType } from '@/components/shared/types/types'

interface Props {
  airStartTime: string | null
  airEndTime: string | null
  variant?: LayoutType
}

export function AirDateInfo({ airStartTime, airEndTime, variant = 'list' }: Props) {
  if (airStartTime === null || airEndTime === null) {
    return null
  }

  const formattedStart = format(airStartTime, DATE_FORMATS.DISPLAY_DATE_SHORT)
  const formattedEnd = format(airEndTime, DATE_FORMATS.DISPLAY_DATE_SHORT)

  if (variant === 'grid') {
    return (
      <div className="flex flex-col w-full">
        <CountdownToStart variant="dark" subtle startTime={new Date(airEndTime)} />
      </div>
    )
  }

  // List variant — compact single line: "Start: X  End: Y  |  Expires: Nd"
  return (
    <div className="flex items-center gap-2">
      <Text variant="base-sm" className="text-secondary">
        Start: {formattedStart}
      </Text>
      <Text variant="base-sm" className="text-secondary">
        End: {formattedEnd}
      </Text>
      <Text variant="base-sm" className="text-secondary">
        |
      </Text>
      <CountdownToStart startTime={new Date(airEndTime)} variant="dark" subtle />
    </div>
  )
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const AirDateInfoSkeleton: React.FC<{
  layout?: LayoutType
}> = ({ layout = 'list' }) => {
  if (layout === 'grid') {
    return (
      <div className="pt-2 pb-2">
        <Skeleton dark className="w-1/4 h-4" />
      </div>
    )
  }
  return <Skeleton dark className="w-[260px] h-[18px] rounded" />
}
